import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress,
} from '@mui/material';
import { MessageListDto } from '../services/messagesService';

interface DeleteMessageDialogProps {
    open: boolean;
    message: MessageListDto | null;
    onConfirm: () => void;
    onCancel: () => void;
    isDeleting: boolean;
}

const DeleteMessageDialog = ({
    open,
    message,
    onConfirm,
    onCancel,
    isDeleting,
}: DeleteMessageDialogProps) => {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
            <DialogTitle>Ta bort meddelande?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Är du säker på att du vill ta bort meddelandet "
                    {message?.title}"?
                </DialogContentText>
                <DialogContentText sx={{ mt: 2 }}>
                    Meddelandet kommer inte längre vara synligt för användare i
                    mobilappen.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={isDeleting}>
                    Avbryt
                </Button>
                <Button
                    onClick={onConfirm}
                    color="error"
                    variant="contained"
                    disabled={isDeleting}
                    startIcon={
                        isDeleting ? (
                            <CircularProgress size={16} color="inherit" />
                        ) : null
                    }
                >
                    {isDeleting ? 'Tar bort...' : 'Ta bort'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteMessageDialog;
